import { render, staticRenderFns } from "./LogearOtp.vue?vue&type=template&id=de707f66&scoped=true&"
import script from "./LogearOtp.vue?vue&type=script&lang=ts&"
export * from "./LogearOtp.vue?vue&type=script&lang=ts&"
import style0 from "./LogearOtp.vue?vue&type=style&index=0&id=de707f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de707f66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VAvatar,VBtn,VCard,VCardSubtitle,VCardTitle,VContainer,VIcon})
